// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Feedback_wrap__k2msj","inner":"Feedback_inner___h9mQ","title":"Feedback_title__L8SAc","decorRight":"Feedback_decorRight__IDsyr","decorLeft":"Feedback_decorLeft__UH6A3"};